import { ModuleConfigurationsState } from '@layout/module-management/store/state/module-configurations.state';

export const moduleConfigurationsStates = [ModuleConfigurationsState];
